import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Icon, Popup, Loader } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import SearchField from '../../components/elements/SearchField'
import ListSelector from '../../components/elements/ListSelector'
import Properties from '../../components/elements/Properties'
import Details from '../../components/elements/Details'
import UpdateMaintenancePopup from '../popups/maintenances/UpdateMaintenancePopup'
import CreateExecutionPopup from '../popups/executions/CreateExecutionPopup'
import UpdateExecutionPopup from '../popups/executions/UpdateExecutionPopup'
import HistoryItemPopup from '../popups/items/HistoryItemPopup'
import Grant from '../elements/Grant'

import GetAction from '../../actions/maintenances/GetFullAction'
import ChangePageAction from '../../actions/app/ChangePageAction'

class MaintenanceViewPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      // Search text of the right search field
      search: '',
      // Is executing maintenance
      isExecute: false,
      // Is editing maintenance infos
      isUpdateMaintenance: false,
      // Is editing execution infos
      isUpdateExecution: false,
      // ID of item currently open in history popup
      itemHistoryId: null,
      // Show only items with below status
      itemShowStatus: null
    }

    // Bind events
    this.onClickExecute = this.onClickExecute.bind(this)
    this.onCloseExecute = this.onCloseExecute.bind(this)
    this.onSelectExecution = this.onSelectExecution.bind(this)
    this.onChangeSearch = this.onChangeSearch.bind(this)
    this.onClickMaintenanceUpdate = this.onClickMaintenanceUpdate.bind(this)
    this.onCloseMaintenanceUpdate = this.onCloseMaintenanceUpdate.bind(this)
    this.onClickExecutionUpdate = this.onClickExecutionUpdate.bind(this)
    this.onCloseExecutionUpdate = this.onCloseExecutionUpdate.bind(this)
    this.onClickItemHistory = this.onClickItemHistory.bind(this)
    this.onCloseItemHistory = this.onCloseItemHistory.bind(this)
    this.onClickItemShowStatus = this.onClickItemShowStatus.bind(this)
  }

  fetch() {
    this.props.fetch(this.props.maintenanceId)
  }

  componentDidMount() {
    this.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // When selected maintenance changes, fetch
    if (
      prevProps.maintenanceId !== this.props.maintenanceId
      &&
      !_.isNull(this.props.maintenanceId)
    ) {
      this.fetch()
    }
  }

  onClickExecute() {
    this.setState({
      isExecute: true
    })
  }

  onCloseExecute(executionId) {
    this.setState({
      isExecute: false
    })
    if (executionId) {
      this.fetch()
      this.onSelectExecution(executionId)
    }
  }

  onSelectExecution(id) {
    this.props.changePage(
      AppConstants.PAGE.MAINTENANCE_VIEW,
      this.props.maintenanceId,
      id
    )
  }

  onChangeSearch(search) {
    this.setState({ search })
  }

  onClickMaintenanceUpdate() {
    this.setState({
      isUpdateMaintenance: true
    })
  }

  onCloseMaintenanceUpdate(isDirty) {
    this.setState({
      isUpdateMaintenance: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickExecutionUpdate() {
    this.setState({
      isUpdateExecution: true
    })
  }

  onCloseExecutionUpdate(isDirty) {
    this.setState({
      isUpdateExecution: false
    })
    if (isDirty) {
      this.fetch()
    }
  }

  onClickItemHistory(itemHistoryId) {
    return () => {
      this.setState({ itemHistoryId })
    }
  }

  onCloseItemHistory() {
    this.setState({
      itemHistoryId: null
    })
  }

  onClickItemShowStatus(itemShowStatus) {
    return () => {
      this.setState({ itemShowStatus })
    }
  }

  render() {
    const next = this.props.data
      ? AppUtils.dateToReminder(this.props.data.next)
      : null
    const selectedExecution = this.props.data && this.props.executionId
      ? _.find(
          this.props.data.executions,
          (execution) => (execution.id === this.props.executionId)
        )
      : null
    const itemsAll = selectedExecution
      ? _.map(
          selectedExecution.items,
          (item) => (_.extend(
            {},
            item,
            {
              number: !_.isNull(this.props.data.product.prefix)
                ? `${this.props.data.product.prefix}${item.number}`
                : null
            }
          ))
        )
      : []
    const itemsNone = selectedExecution
      ? _.filter(
          itemsAll,
          (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE)
        )
      : []
    const itemsSuccess = selectedExecution
      ? _.filter(
          itemsAll,
          (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS)
        )
      : []
    const itemsFailure = selectedExecution
      ? _.filter(
          itemsAll,
          (item) => (item.status === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE)
        )
      : []
    let listItems = null
    if (!_.isNull(selectedExecution)) {
      switch (this.state.itemShowStatus) {
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS:
          listItems = itemsSuccess
          break
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE:
          listItems = itemsFailure
          break
        case AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE:
          listItems = itemsNone
          break
        default:
          listItems = itemsAll
          break
      }
    }
    return (
      !_.isNull(this.props.maintenanceId)
        ? <React.Fragment>
            <Page direction={Page.DIRECTION.COL}>
              {
                this.props.isFetching || !this.props.data
                  ? <Page.Element
                      flex='1 1 100%'
                    >
                      <Loader
                        active={true}
                        content='Chargement...'
                        size='huge'
                      />
                    </Page.Element>
                  : <React.Fragment>
                      <Page.Element
                        flex='0 0 auto'
                        withBorders={true}
                      >
                        <Header
                          title='Description de la maintenance'
                          right={
                            <Grant role={Grant.ROLE.MANAGE}>
                              <Button
                                compact={true}
                                icon='pencil'
                                color='orange'
                                onClick={this.onClickMaintenanceUpdate}
                              />
                            </Grant>
                          }
                          alignTop={true}
                        />
                        <Properties
                          content={[
                            {
                              key: 'Matériel',
                              value: this.props.data.product.name
                            },
                            {
                              key: 'Maintenance',
                              value: this.props.data.name
                            },
                            {
                              key: 'Récurrence',
                              value: AppUtils.displayPeriodicity(this.props.data.periodicity)
                            },
                            {
                              key: 'Prochaine',
                              value: (
                                <React.Fragment>
                                  {next.text}
                                  {' '}
                                  {
                                    next.icon
                                      ? <Details
                                          icon={next.icon}
                                          action={Details.ACTION.HOVER}
                                          content={next.details}
                                        />
                                      : null
                                  }
                                </React.Fragment>
                              )
                            },
                            {
                              key: 'Effectuée par',
                              value: this.props.data.outside ? 'Externe' : 'SIS'
                            }
                          ]}
                        />
                      </Page.Element>
                      <Page.Container
                        flex='1 1 auto'
                        direction={Page.DIRECTION.ROW}
                      >
                        <Page.Element
                          flex='1 1 20%'
                          style={{
                            display: 'flex',
                            flexDirection: 'column'
                          }}
                        >
                          <div
                            style={{
                              flex: '0 0 38px',
                              display: 'flex',
                              flexDirection: 'row'
                            }}
                          >
                            <div style={{ flex: '0 1 auto' }}>
                              <Grant role={Grant.ROLE.MAINTENANCE}>
                                <Popup
                                  trigger={
                                    <Button
                                      icon='play'
                                      color='green'
                                      onClick={this.onClickExecute}
                                      style={{ margin: 0 }}
                                    />
                                  }
                                  inverted={true}
                                  on='hover'
                                  position='right center'
                                >
                                  Effectuer la maintenance
                                </Popup>
                              </Grant>
                            </div>
                            <div style={{
                              flex: '1 0 auto',
                              margin: '0 8px'
                            }}>
                              <SearchField
                                value={this.state.search}
                                onChange={this.onChangeSearch}
                              />
                            </div>
                          </div>
                          <ListSelector
                            style={{
                              flex: '1 1 auto',
                              marginTop: '8px'
                            }}
                            selected={this.props.executionId}
                            onSelect={this.onSelectExecution}
                          >
                            {
                              _.map(
                                _.filter(
                                  this.props.data.executions,
                                  (execution) => (
                                    AppUtils.search(AppUtils.displayDate(execution.date, '?', false), this.state.search)
                                    ||
                                    AppUtils.search(execution.name, this.state.search)
                                  )
                                ),
                                (execution) => (
                                  <ListSelector.Item
                                    key={execution.id}
                                    value={execution.id}
                                    text={`${AppUtils.displayDate(execution.date, '?', false)} - ${execution.name}`}
                                  />
                                )
                              )
                            }
                          </ListSelector>
                        </Page.Element>
                        <Page.Container
                          flex='4 4 80%'
                          direction={Page.DIRECTION.COL}
                        >
                          {
                            selectedExecution
                              ? <React.Fragment>
                                  <Page.Element
                                    flex='0 0 auto'
                                    withBorders={true}
                                  >
                                    <Header
                                      title="Description de l'exécution"
                                      right={
                                        <Grant role={Grant.ROLE.MANAGE}>
                                          <Button
                                            compact={true}
                                            icon='pencil'
                                            color='orange'
                                            onClick={this.onClickExecutionUpdate}
                                          />
                                        </Grant>
                                      }
                                      alignTop={true}
                                    />
                                    <Properties
                                      content={[
                                        {
                                          key: 'Date',
                                          value: AppUtils.displayDate(selectedExecution.date)
                                        },
                                        {
                                          key: 'Titre',
                                          value: selectedExecution.name
                                        },
                                        {
                                          key: 'Saisie par',
                                          value: selectedExecution.user.name
                                        },
                                        {
                                          key: 'Participants',
                                          value: selectedExecution.people
                                        },
                                        {
                                          key: 'Résultat',
                                          value: (
                                            <React.Fragment>
                                              {
                                                _.size(itemsFailure) > 0
                                                  ? <div>
                                                      <Icon
                                                        name='warning circle'
                                                        color='red'
                                                      />
                                                      {
                                                        _.size(itemsSuccess) === 0
                                                          ? 'Echec pour toutes les pièces concernées'
                                                          : `Echec pour ${_.size(itemsFailure)} pièce${_.size(itemsFailure) > 1 ? 's' : ''}`
                                                      }
                                                    </div>
                                                  : null
                                              }
                                              {
                                                _.size(itemsSuccess) > 0
                                                  ? <div>
                                                      <Icon
                                                        name='checkmark'
                                                        color='green'
                                                      />
                                                      {
                                                        _.size(itemsFailure) === 0
                                                          ? 'Succès pour toutes les pièces concernées'
                                                          : `Succès pour ${_.size(itemsSuccess)} pièce${_.size(itemsSuccess) > 1 ? 's' : ''}`
                                                      }
                                                    </div>
                                                  : null
                                              }
                                              {
                                                _.size(itemsNone) > 0
                                                  ? <div>
                                                      <Icon
                                                        name='warning sign'
                                                        color='orange'
                                                      />
                                                      {`Pas exécutée pour ${_.size(itemsNone)} pièce${_.size(itemsNone) > 1 ? 's' : ''}`}
                                                    </div>
                                                  : null
                                              }
                                            </React.Fragment>
                                          )
                                        },
                                        {
                                          key: 'Remarque',
                                          value: selectedExecution.remark
                                        }
                                      ]}
                                    />
                                  </Page.Element>
                                  <Page.Element
                                    flex='1 1 auto'
                                    withBorders={true}
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column'
                                    }}
                                  >
                                    <Header
                                      style={{
                                        flex: '0 1 auto'
                                      }}
                                      title='Liste des pièces'
                                      right={
                                        <React.Fragment>
                                          Afficher
                                          <Button.Group
                                            compact={true}
                                            style={{
                                              marginLeft: '8px'
                                            }}
                                          >
                                            <Popup
                                              trigger={
                                                <Button
                                                  icon='list layout'
                                                  color={_.isNull(this.state.itemShowStatus) ? 'gray' : undefined}
                                                  basic={!_.isNull(this.state.itemShowStatus)}
                                                  onClick={this.onClickItemShowStatus(null)}
                                                />
                                              }
                                              inverted={true}
                                              on='hover'
                                              position='top center'
                                            >
                                              Tout
                                            </Popup>
                                            <Popup
                                              trigger={
                                                <Button
                                                  icon='checkmark'
                                                  color={this.state.itemShowStatus === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS ? 'green' : undefined}
                                                  basic={this.state.itemShowStatus !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS}
                                                  onClick={this.onClickItemShowStatus(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.SUCCESS)}
                                                />
                                              }
                                              inverted={true}
                                              on='hover'
                                              position='top center'
                                            >
                                              Succès
                                            </Popup>
                                            <Popup
                                              trigger={
                                                <Button
                                                  icon='warning circle'
                                                  color={this.state.itemShowStatus === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE ? 'red' : undefined}
                                                  basic={this.state.itemShowStatus !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE}
                                                  onClick={this.onClickItemShowStatus(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.FAILURE)}
                                                />
                                              }
                                              inverted={true}
                                              on='hover'
                                              position='top center'
                                            >
                                              Echec
                                            </Popup>
                                            <Popup
                                              trigger={
                                                <Button
                                                  icon='warning sign'
                                                  color={this.state.itemShowStatus === AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE ? 'orange' : undefined}
                                                  basic={this.state.itemShowStatus !== AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE}
                                                  onClick={this.onClickItemShowStatus(AppConstants.PRODUCT.ITEM.MAINTENANCE.STATUS.NONE)}
                                                />
                                              }
                                              inverted={true}
                                              on='hover'
                                              position='top center'
                                            >
                                              Pas exécuté
                                            </Popup>
                                          </Button.Group>
                                        </React.Fragment>
                                      }
                                    />
                                    <Table
                                      columns={_.union(
                                        // N°
                                        !_.isNull(this.props.data.product.prefix)
                                          ? [ ColumnsProvider.itemNumberFull ]
                                          : [],
                                        [
                                          // Emplacement
                                          ColumnsProvider.locationStickers,
                                          // Compartiment
                                          ColumnsProvider.itemCompartmentBasic,
                                          // Status
                                          ColumnsProvider.executionItemStatus,
                                          // Action
                                          ColumnsProvider.itemActions(false, this.onClickItemHistory)
                                        ]
                                      )}
                                      data={listItems}
                                      error={null}
                                      isLoading={false}
                                      emptyMessage="Aucune pièce concernée."
                                    />
                                  </Page.Element>
                                </React.Fragment>
                              : <Page.Element
                                  flex='1 1 100%'
                                >
                                  Aucune exécution sélectionnée.
                                </Page.Element>
                          }
                        </Page.Container>
                      </Page.Container>
                    </React.Fragment>
              }
            </Page>
            {
              this.state.isUpdateMaintenance && !_.isNull(this.props.maintenanceId)
                ? <UpdateMaintenancePopup
                    id={this.props.maintenanceId}
                    onClose={this.onCloseMaintenanceUpdate}
                  />
                : null
            }
            {
              this.state.isUpdateExecution && !_.isNull(this.props.executionId)
                ? <UpdateExecutionPopup
                    id={this.props.executionId}
                    onClose={this.onCloseExecutionUpdate}
                  />
                : null
            }
            {
              this.state.isExecute && this.props.data
                ? <CreateExecutionPopup
                    maintenance={this.props.data}
                    onClose={this.onCloseExecute}
                  />
                : null
            }
            {
              !_.isNull(this.state.itemHistoryId) && !_.isNull(this.props.selected)
                ? <HistoryItemPopup
                    id={this.state.itemHistoryId}
                    onClose={this.onCloseItemHistory}
                  />
                : null
            }
          </React.Fragment>
        : <div>
            Erreur: Aucune maintenance sélectionnée.
          </div>
    )
  }
}

MaintenanceViewPage.propTypes = {
  // Properties

  // Redux State
  maintenanceId: PropTypes.number.isRequired,
  executionId: PropTypes.number.isRequired,
  data: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    maintenanceId: state.entities.maintenances.view,
    executionId: state.entities.executions.view,
    data: state.entities.maintenances.get.full.data,
    isFetching: state.entities.maintenances.get.full.isFetching,
    error: state.entities.maintenances.get.full.error
  }),
  (dispatch) => ({
    fetch: (id) => (dispatch(GetAction({ id }))),
    changePage: (page, id=undefined, execution=undefined) => (dispatch(ChangePageAction(page, _.omit({ id, execution }, _.isUndefined))))
  })
)(MaintenanceViewPage)



// WEBPACK FOOTER //
// ./src/containers/pages/MaintenanceViewPage.js